var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCultive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1016 9.3325C26.1016 9.3325 35.7724 5.9225 39.8433 4.1325C40.0295 4.04932 40.2308 4.00434 40.4351 4.0003C40.6394 3.99625 40.8424 4.03322 41.0317 4.10896C41.2211 4.1847 41.393 4.29764 41.5368 4.44092C41.6807 4.5842 41.7936 4.75484 41.8687 4.9425L44.8459 12.1925C44.9258 12.3798 44.9667 12.5812 44.966 12.7845C44.9652 12.9878 44.9229 13.1888 44.8416 13.3756C44.7603 13.5623 44.6416 13.731 44.4927 13.8713C44.3438 14.0117 44.1677 14.121 43.975 14.1925L30.456 19.2825L26.1016 9.3325Z",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5244 75.8425C55.4448 75.8425 66.7295 64.6989 66.7295 50.9525C66.7295 37.2061 55.4448 26.0625 41.5244 26.0625C27.604 26.0625 16.3193 37.2061 16.3193 50.9525C16.3193 64.6989 27.604 75.8425 41.5244 75.8425Z",
    fill: "#3098F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9875 47.6123C12.4103 49.5623 3.06345 55.3323 4.07611 58.6123C4.99763 61.5323 13.8888 61.2423 17.6559 60.6923C26.9125 59.3902 36.0098 57.1553 44.8052 54.0223C53.7618 50.9977 62.3834 47.0808 70.5369 42.3323C74.5875 39.9023 80.5521 35.3323 73.9495 34.3323C69.4848 33.8284 64.9678 34.0174 60.5622 34.8923",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1118 9.58252C29.1498 16.5825 30.9726 23.7025 33.97 30.9425",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCultive);
export default __webpack_public_path__ + "static/media/icon-cultive.4513021704437124fdf71963a1c73e69.svg";
export { ForwardRef as ReactComponent };